import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {environment} from '@env/environment';
import {OneEdtechRequestModel} from '@app/views/admin/1edtech/one-edtech.models';

@Injectable()
export class OneEdtechService {

    constructor(
        private http: HttpClient,
        private router: Router,
    ) {  }

    submitSuppliersForm(form: Object){
        const url = `${environment.datahubBaseURI}/api/v2/oneedtech/optsin-free-trial`;
        const body = {
            organizationName: form['orgName'],
            address: form['address'],
            country: form['country'],
            url: form['website'],
            primaryContactFirstName: form['contactFirstName'],
            primaryContactLastName: form['contactLastName'],
            primaryContactEmail: form['contactEmail'],
            gg4lOrganizationId: form['orgGuid'],
            productNames: form['productNames'],
            organizationSize: form['organizationSize'],
            tos: form['termsOfService']
        };

        return this.http.post(url, body)
            .pipe(catchError(this.handleError));

    }

    sendOneEdTechRequest(districtId) {
        return this.http
            .post<any>(`${environment.datahubBaseURI}/api/v2/oneedtech/districts/notify/${districtId}`, {});
    }

    checkProviderOneEdTechRequestStatus(districtId: string) {
        return this.http
            .get<OneEdtechRequestModel>(`${environment.datahubBaseURI}/api/v2/oneedtech/districts/status/${districtId}`);
    }

    checkVendorOneEdTechRequestStatus(orgId: string) {
        return this.http
            .get<OneEdtechRequestModel>(`${environment.datahubBaseURI}/api/v2/oneedtech/vendors/status/${orgId}`);
    }

    launch() {
        return this.http
            .get<any>(`${environment.ltiPlatformBaseURI}/lti13/sso/launch`);
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.message}`);
        }
        return throwError(
            'Something bad happened, please try again later.');
    }
}
